import { useRef } from "react";
import compressImage from "../../../../utils/CompressImage";

// Camera of the vehicle photos (tampak depan / kiri / kanan / belakang): a native <input type="file" capture>,
// so on mobile it opens the device's own camera / gallery picker.
// The photo of a checklist row is taken in the row popover instead (see useEditorNote.handleOnClickFoto).
const useEditorCamera = ({ savePengecekanBase64Image }) => {
  const cameraInputRef = useRef(null);
  // the field the next picked photo is for
  const cameraTargetRef = useRef(null);

  // handle UI event section

  const handleOnClickCameraPreview = (field) => {
    cameraTargetRef.current = { field };
    if (cameraInputRef.current) {
      // reset so picking the same file twice in a row still fires onChange
      cameraInputRef.current.value = "";
      cameraInputRef.current.click();
    }
  };

  const handleCameraFileChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file || !cameraTargetRef.current) return;

    const { field } = cameraTargetRef.current;

    // a raw camera photo is several MB, the server only accepts 2048 KB per photo field: resize first
    let photo = file;
    try {
      photo = await compressImage(file);
    } catch (err) {
      console.log("COMPRESS PHOTO ERROR", err);
    }

    const reader = new FileReader();
    reader.onload = () => {
      savePengecekanBase64Image({ field, base64Image: reader.result });
    };
    reader.readAsDataURL(photo);
  };

  return {
    cameraInputRef,
    handleOnClickCameraPreview,
    handleCameraFileChange,
  };
};

export default useEditorCamera;
